///<reference path='AutocompleterField.ts'/>
'use strict';
/*
    Creates an autocompleter field.
    Results are exposed as `ac.data`.
*/
namespace Autocompleter {

    class Autocompleter extends AutocompleterField {

        private selectAttrFn: (item: any) => void;
        private setPrefixDebounced: (prefix: string) => void;

        constructor (
            public $scope: any,
            public $element: JQuery,
            public $parse: ng.IParseService,
            public $route: ng.route.IRouteService,
            public autocompleter: any,
            public resourceService: Core.ResourceService,
            public $timeout: ng.ITimeoutService,
            public $q: ng.IQService
        ) {
            super();

            this.setPrefixDebounced = _.debounce(prefix => {
                this.prefix = prefix;
                $scope.$apply();
            }, 100);

            // Watch for initial value
            this.$scope.$watchCollection('ac.currentValue', value => {
                let selected: any = _.isArray(value) ? value[0] : value;
                if (selected) {
                    let title = selected[this.titleProp];
                    if (title) {
                        this.setPrefixDebounced(title);
                    }
                } else {
                    this.prefix = '';
                }
            });

            // Wrap `select` attribute fn
            this.selectAttrFn = this.select;
            this.select = (item) => {
                this.selectAttrFn({item: item});
                this.selectItem(item);
            };
            this.titleProp = this.titleProp || 'Title';

            // set focus on input field when required
            this.$scope.$watch(() => this.setFocus, value => {
                if (value === true) {
                    this.$timeout(() => {
                        this.inputField && this.inputField.focus();
                    });
                }
            });

        }

        focus () {
            if (TRPCONFIG.Domain.AllowZeroInputDestinationAutocompleter
                && TRPCONFIG.Domain.DeviceType === 'Desktop'
                && (this.prefix === '' || this.prefix === undefined)) {
                this.fetch();
            }
        }

        update (result: any): void {
            let data = result.data,
                area = this.getArea();

            if (['businesscustomers', 'travelAgents', 'coworkers', 'userAccounts'].indexOf(area) > -1) {
                this.data = data;
            }
            else if (['transfers', 'flights', 'flights-departure', 'marhaba', 'parking'].indexOf(area) > -1) {
                this.data = this.addHeader(data, 'AIRPORTS');
            }
            else if (area === 'resorts') {
                this.data = this.addHeader(data, 'RESORTSPLUSHOTELS');
            }
            else {
                this.data = this._groupHotelResults(data);
            }

            if (!this.data || !this.data.length) {
                this.data = null;
                this.$scope.$emit('flash:error', this.resourceService.get('NOMATCHES'));
            }
        }

        selectItem (item: any): void {
            if (item && item[this.titleProp]){
                angular.isArray(this.currentValue) ? this.currentValue[0] = item : this.currentValue = item;
            }
        }

        blur () {
            this.setFocus = false;

            // timeout is to prevent blur firing immediately before we select a menu item
            this.$timeout(() => {

                if (!this.prefix &&
                    !TRPCONFIG.Domain.AllowZeroInputDestinationAutocompleter &&
                    TRPCONFIG.Domain.DeviceType !== 'Desktop') {
                    // we have no prefix so clear the current value
                    angular.isArray(this.currentValue) ? this.currentValue.length = 0 : delete this.currentValue;
                    return;
                }
                if (!this.data || !this.data.length) {
                    // no data
                    return;
                }

                let value = this.currentValue && this.currentValue[0] || this.currentValue,
                    title = value && value[this.titleProp],
                    isCurrentValueInMenu = _.some(this.data, (d: any) => d[this.titleProp] === title);

                if (!isCurrentValueInMenu) {
                    // current value is not in our data so select the first option
                    let firstItem = _.find(this.data, (d: any) => !d.header);
                    if (firstItem) {
                        this.select(angular.copy(firstItem));
                        return;
                    }
                }
                if (title) {
                    // set the autcompleter text to match the current value
                    this.setPrefixDebounced(title);
                }

            }, 200);
        }

        private _groupHotelResults (data: any[]) {
            let hotels:any = [];
            let destinations:any = [];

            angular.forEach(data, item => {
                if (item.EstablishmentId !== 0) {
                    hotels.push(item);
                } else {
                    destinations.push(item);
                }
            });
            return this.addHeader(destinations, 'DESTINATIONS')
                    .concat(this.addHeader(hotels, 'HOTELS'));
        }
    }

    angular
        .module('TR')
        .directive('autocompleter', (): ng.IDirective => {
            return {
                restrict: 'E',
                replace: true,
                scope: {},
                controllerAs: 'ac',
                bindToController: {
                    placeholder: '@',
                    select: '&',
                    deselect: '&',
                    setFocus: '=?',
                    currentValue: '=?',
                    areaOverride: '@',
                    focusTracker: '=',
                    minPrefix: '@',
                    notActive: '@',
                    titleProp:'@',
                    filterFunction:'&?',
                    iconName: '@?'
                },
                templateUrl: 'partials/home/directivetemplate?type=Autocompleter',
                controller: Autocompleter,
                transclude: true,
                link: (
                    scope: any,
                    el: JQuery
                ) => {
                    scope.ac.inputField = el.find('input');
                }
            };
        });
}
